<template>
  <div class="main_right">
    <breadcrumb :breadcrumb="config.breadcrumb" />
    <div class="flexBox">
      <text-title mainTitle="收款账户配置" subheading="" />
      <a @click="toModifyConfig">修改</a>
    </div>
    <ul>
      <li>
        <b>收款账户：</b>
        <span>{{ aliAccountName || '暂无' }}</span>
      </li>
      <li>
        <b>支付宝账号：</b>
        <span>{{ aliAccountNo || '暂无' }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
  import {errorHandler} from '../../../utils/errorHandler'
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import {api} from '../../api/ElectronicManagement'
  import TextTitle from '../../../components/Text/TextTitle'

  export default {
    components: {
      TextTitle,
      Breadcrumb
    },
    name: 'electronic-config',
    data () {
      return {
        config: {
          breadcrumb: [{
            value: '智慧用电',
            name: 'electronic-over-view'
          }, {
            value: '收款账户配置',
          }],
        },
        aliAccountName: '',
        aliAccountNo: '',
      }
    },
    created () {
      this.getAliAccount()
    },
    methods: {
      toModifyConfig () {
        this.$router.push({
          name: 'electronic-account-modify'
        })
      },
      getAliAccount () {
        this.$axios.get(api.getAliAccount, {})
          .then(res => {
            let data = res.data.data
            this.aliAccountName = data.aliAccountName
            this.aliAccountNo = data.aliAccountNo
          })
          .catch(errorHandler('获取收款账户数据失败'))
      }
    }
  }
</script>

<style scoped>
  .main_right {
    text-align: left;
  }

  .flexBox {
    display: flex;
    justify-content: space-between;
  }

  .flexBox a{
    line-height: 58px;
    margin-right: 40px;
    cursor: pointer;
    color: #00a0e6;
  }
  .flexBox a:hover{
    color: #06b3ff;
  }

  .main_right ul {
    width: 80%;
    margin: 10px auto 0;
    line-height: 40px;
  }

  .main_right ul li {
    width: 100%;
    padding: 4px 0;
    margin-bottom: 10px;
  }
  .main_right ul li b {
    color: #48576A;
    font-weight: 400;
    display: inline-block;
    width: 120px;
    text-align: right;
    margin-right: 15px;
  }

  .main_right ul li span{
    color:#333;
  }
</style>



// WEBPACK FOOTER //
// src/view/ElectronicManagement/ElectronicAccountConfig/ElectronicAccountCenter.vue